import { render } from "./CancelledOrderIsland.vue?vue&type=template&id=1572e6cc"
import script from "./CancelledOrderIsland.vue?vue&type=script&lang=js"
export * from "./CancelledOrderIsland.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__